import React, { useState } from "react";
import { toast } from "sonner";
import { Clock } from "lucide-react";
import { formatLoggedHours } from "@/lib/dailyTaskStatus";

/**
 * Phase 154 — "Log Hours" inline cell, shared by all three Task Hub tabs
 * (Tasks/Priorities/Social Posts). Click the badge → a small number input
 * appears → Enter/blur logs it via the caller's `onLog(hours)` (each tab
 * wires this to its own `.../log-time` endpoint, which both creates a real
 * Timesheet entry AND returns the row's updated `total_minutes`).
 */
export default function TaskHubLogHours({ totalMinutes, onLog, testId }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const h = Number(val);
    if (!h || h <= 0 || h > 24) { toast.error("Enter hours between 0 and 24"); return; }
    setBusy(true);
    try { await onLog(h); setVal(""); setEditing(false); }
    finally { setBusy(false); }
  };

  if (editing) {
    return (
      <input
        type="number"
        step="0.25"
        min="0"
        max="24"
        autoFocus
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={() => { if (val) submit(); else setEditing(false); }}
        onKeyDown={(e) => {
          if (e.key === "Enter") { e.preventDefault(); submit(); }
          if (e.key === "Escape") setEditing(false);
        }}
        placeholder="hrs"
        disabled={busy}
        className="h-7 text-[11px] rounded-sm border border-[#F54800] px-1 w-[64px] shrink-0"
        data-testid={`${testId}-input`}
      />
    );
  }
  return (
    <button
      type="button"
      onClick={() => setEditing(true)}
      className="inline-flex items-center gap-0.5 text-[10px] text-slate-500 bg-slate-100 hover:bg-slate-200 px-1.5 py-0.5 rounded-sm w-[64px] shrink-0 justify-center transition-colors"
      data-testid={testId}
      title="Click to log hours → Timesheet"
    >
      <Clock size={9} /> {totalMinutes > 0 ? formatLoggedHours(totalMinutes) : "Log"}
    </button>
  );
}
